import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dmz: null,
};
export const dmzSlice = createSlice({
  name: "dmz",
  initialState,
  reducers: {
    setDmz: (state, action) => {
      state.dmz = action.payload;
    },
    setLogoutDmz: (state, action) => {
      state.dmz = null;
    },
  },
});

export const { setDmz, setLogoutDmz } = dmzSlice.actions;

export default dmzSlice.reducer;
